import { render, staticRenderFns } from "./IconMagneto.vue?vue&type=template&id=0aa3583c&scoped=true&"
import script from "./IconMagneto.vue?vue&type=script&lang=js&"
export * from "./IconMagneto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa3583c",
  null
  
)

export default component.exports